<h2 mat-dialog-title>Modifica foto profilo</h2>

  <mat-dialog-content>
      <div class="file-upload-container">
      <!-- Preview -->
      <div *ngIf="previewUrl" class="preview-container">
        <img [src]="previewUrl" alt="Preview" class="preview-image">
        <button 
          mat-icon-button 
          color="warn" 
          class="remove-btn"
          (click)="removeSelectedFile()"
          matTooltip="Remove image"
          [matTooltipShowDelay]="showDelay.value"
          [matTooltipHideDelay]="hideDelay.value">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- File Input -->
      <div *ngIf="!previewUrl" class="upload-area">
        <input 
          type="file" 
          #fileInput
          (change)="onFileSelected($event)"
          accept="image/*"
          hidden>
        
        <button 
          mat-raised-button 
          color="primary"
          (click)="fileInput.click()">
          <mat-icon>cloud_upload</mat-icon>
          Scegli immagine
        </button>
        
        <p class="file-hint">Formati supportati: JPG, PNG, GIF. Dimensione massima: 5MB</p>
      </div>

      <!-- Loading Spinner -->
      <mat-spinner *ngIf="isUploading" diameter="40" class="spinner"></mat-spinner>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Indietro</button>
    <button mat-raised-button color="primary" (click)="confirm()">
      <mat-icon>edit</mat-icon>
        Salva
    </button>
  </mat-dialog-actions>
